<script setup lang="ts">
import { ButtonNavigation } from '~/lib/models/ui/bottom-navigation'

const layoutStore = useLayoutStore()
const props = defineProps<{ buttonNavigation: ButtonNavigation }>()
const route = useRoute()

const contentAccount = { tKey: 'onboarding.stepAccount', action: true, isLast: false }

const isHomePath = computed(() => {
  if (props.buttonNavigation.path !== '/') return false
  return true
})
const isRouteHomeActive = computed(() => {
  if (!isHomePath.value) return false
  const routeName = route.name
  if (routeName === 'restaurants-citySlug-restaurantSlug-orders') return true
  return false
})

const isAccountBtn = (urlPath: string) =>
  /^(\/mi-cuenta|\/minha-conta|\/my-account|\/mon-compte)$/.test(urlPath)
</script>

<template>
  <div v-if="buttonNavigation.path === '/more'">
    <button
      class="flex h-full flex-col items-center justify-between"
      @click="layoutStore.openMenuSideBar()"
    >
      <img class="h-8 w-8" :src="buttonNavigation.icon" :alt="buttonNavigation.title" />
      <p class="text-[10px] font-normal text-mcd-secondaryDarkGrey">
        {{ buttonNavigation.title }}
      </p>
    </button>
  </div>

  <NuxtLink
    v-else-if="!isAccountBtn(buttonNavigation.path)"
    :to="buttonNavigation.path"
    class="grayscale-[1] filter"
    :class="{ 'router-link-active': isHomePath && isRouteHomeActive }"
  >
    <div class="flex h-full flex-col items-center justify-between">
      <img class="h-8 w-8" :src="buttonNavigation.icon" :alt="buttonNavigation.title" />
      <p class="bottom-bar-title text-[10px] font-normal text-mcd-secondaryDarkGrey">
        {{ buttonNavigation.title }}
      </p>
    </div>
  </NuxtLink>

  <PopperWrapper v-else data-popper="stepAccount" placement="top">
    <template #default="{ isShowed }">
      <NuxtLink
        :to="buttonNavigation.path"
        :class="{
          'router-link-active': (isHomePath && isRouteHomeActive) || isShowed,
          'grayscale-[1] filter': !isShowed,
        }"
      >
        <div class="flex h-full flex-col items-center justify-between">
          <img class="h-8 w-8" :src="buttonNavigation.icon" :alt="buttonNavigation.title" />
          <p class="bottom-bar-title text-[10px] font-normal text-mcd-secondaryDarkGrey">
            {{ buttonNavigation.title }}
          </p>
        </div>
      </NuxtLink>
    </template>
    <template #content="{ close }">
      <McdPopper :close="close" :content="contentAccount" />
    </template>
  </PopperWrapper>
</template>

<style>
.router-link-active {
  @apply filter-none;
}

.router-link-active .bottom-bar-title {
  @apply font-bold text-mcd-black;
}
</style>
